export default {
  Gab01: {
    class: "mainClass",
    comp: [
      {
        class: "banner__container",
        comp: [
          {
            class: "bannerMain",
            comp: [
              {
                class: "bannerIcon",
                comp: "banner-icon2"
              },
              {
                class: "bannerContent",
                comp: "banner-content"
              }
            ]
          },
          {
            class: "bannerButton",
            comp: "banner-button"
          }
        ]
      }
    ]
  },
  Gab02: {
    class: "mainClass",
    comp: [
      {
        class: "banner-container",
        comp: [
          {
            comp: "banner-icon"
          },
          {
            class: "details",
            comp: [
              {
                comp: "banner-content"
              },
              {
                comp: "banner-button"
              }
            ]
          }
        ]
      }
    ]
  },
  Gab03: {
    class: "mainClass",
    comp: [
      {
        comp: "banner-html-text"
      },
      {
        comp: "banner-content"
      },
      {
        comp: "banner-button"
      },
      {
        comp: "banner-policy"
      }
    ]
  },
  Gab04: {
    class: "mainClass",
    comp: [
      {
        class: "banner-container",
        comp: [
          {
            comp: "banner-icon"
          },
          {
            class: "details",
            comp: [
              {
                comp: "banner-content"
              },
              {
                comp: "banner-button"
              }
            ]
          }
        ]
      }
    ]
  },
  Gab05: {
    class: "mainClass",
    comp: [
      {
        class: "banner-container",
        comp: [
          {
            comp: "banner-icon"
          },
          {
            class: "details",
            comp: [
              {
                comp: "banner-content"
              },
              {
                comp: "banner-button"
              }
            ]
          }
        ]
      }
    ]
  },
  Gab06: {
    class: "mainClass",
    comp: [
      {
        class: "banner-container",
        comp: [
          {
            class: "bannerImg",
            comp: "banner-img"
          },
          {
            class: "details",
            comp: [
              {
                class: "banner-title",
                comp: [
                  {
                    comp: "BannerTitle"
                  }
                ]
              },
              {
                class: "banner-content",
                comp: [
                  {
                    class: "description",
                    comp: "BannerDescription"
                  },
                  {
                    class: "bannerPolicy",
                    comp: "bannerPolicy"
                  }
                ]
              },
              {
                class: "banner-cta",
                comp: [
                  {
                    comp: "banner-button"
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  Gab07: {
    class: "mainClass",
    comp: [
      {
        class: "banner-container",
        comp: [
          {
            class: "banner-content",
            comp: "banner-content"
          },
          {
            class: "banner-cta",
            comp: "banner-button"
          },
          {
            class: "bannerPolicy",
            comp: "bannerPolicy"
          }
        ]
      }
    ]
  },
  Gab08: {
    class: "mainClass",
    comp: [
      {
        class: "pastille-container",
        comp: "BannerPastille"
      },
      {
        class: "banner-title",
        comp: "BannerTitle"
      },
      {
        class: "description",
        comp: "BannerDescription"
      },
      {
        class: "banner-cta",
        comp: "banner-button"
      },
      {
        class: "banner-policy",
        comp: "BannerPolicy"
      }
    ]
  },
  Gab09: {
    class: "banner selfcare-banner-celebrus gab-09",
    comp: [
      {
        class: "mainClass",
        comp: [
          {
            class: "content-offre",
            comp: [
              {
                class: "pastille-container",
                comp: "BannerPastille"
              },
              {
                class: "content-offre-wrapper",
                comp: [
                  {
                    class: "banner-title",
                    comp: "BannerTitle"
                  },
                  {
                    class: "description",
                    comp: "BannerDescription"
                  }
                ]
              }
            ]
          },
          {
            class: "banner-cta",
            comp: "banner-button"
          }
        ]
      }
    ],
  },
  Gab20: {
    comp: "banner-empty"
  }
};
